import React from 'react';

const About = ({ about }) => {
    return (
        <div className="mt-2">
            <p className="f-36 mb-4 me-2 mt-3 poly">About</p>
            <div className="about-card">
                <div
                    className="about-text"
                    dangerouslySetInnerHTML={{
                        __html: about || 'No details provided yet.',
                    }}
                />
            </div>
        </div>
    );
};

export default About;
